import React, { useEffect } from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import styled from 'styled-components';
import homePageBackgroundLawyer from 'images/homepage-background-lawyer.jpg';
import sanlamLogo from 'images/icon-sanlam.png';
import messages from 'containers/HomePage/messages';
import { translate } from 'containers/services/translate';
import { pushTo } from 'containers/services/routes-helper';
import { PAGES } from 'routes';
import PendingClaims from 'containers/HomePage/PendingClaims';
import ValidatedClaims from 'containers/HomePage/ValidatedClaims';
import { requestStatsClaims } from 'containers/HomePage/actions';
import { makeSelectStatsClaims } from 'containers/HomePage/selectors';
import { COUNT_CLAIMS_STATS } from 'containers/HomePage/constants';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { makeSelectKeycloakToken } from 'containers/AppContainer/selectors';
import { COLORS } from 'constants/design';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import PrimaryButton from 'components/Buttons/PrimaryButton';
export interface HomePageProps {
  intl: IntlShape;
  requestStatsClaims: Function;
  statsClaims: any;
  keyclokToken: string | null;
}

const Container = styled.div`
  &&.container {
    height: 400px;
    width: 100%;
    margin-top: 60px;
    background-color: ${COLORS.NAVY};
    background-image: url(${homePageBackgroundLawyer});
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 5px;
    background-position: 50% 50%;
    position: relative;
  }
  .bannerContainer {
    display: flex;
    width: 50%;
    height: 223px;
    position: relative;
    position: relative;
    bottom: -57px;
  }
  .custom-border {
    height: 100%;
    border: 10px solid #f2a900;
    margin-right: 5px;
  }
  .logo {
    padding: 0 10px;
  }
  .logo-image {
    width: 32px;
    height: 32px;
  }
  .identificationCTA {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 50%;
  }
  .title {
    font: Bold 31px Roboto;
    letter-spacing: 0;
    color: #ffffff;
  }
  .subTitle {
    font: Regular 16px Roboto;
    letter-spacing: 0;
    color: #d8d8d8;
  }
  #primary-button-style {
    width: 223px;
    height: 46px;
    color: #333e48;
    text-transform: none;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-around;
  }
`;
const Claims = styled.div`
  .claims {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }
  .pendingClaims {
    padding-top: 32px;
    width: 50%;
    margin-left: 15px;
  }
  .validatedClaims {
    padding-top: 32px;
    width: 50%;
    margin-right: 15px;
  }
`;

const HomePage: React.FC<HomePageProps> = (props): JSX.Element => {
  /* istanbul ignore next */
  useEffect(() => {
    /* istanbul ignore next */
    if (props.keyclokToken)
      props.requestStatsClaims({ count: COUNT_CLAIMS_STATS });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.keyclokToken]);

  return (
    <div>
      <Container className="container">
        <div className="bannerContainer">
          <div className="custom-border" />
          <div className="logo">
            <img
              src={sanlamLogo}
              alt="SanlamAllianz-logo"
              className="logo-image"
            />
          </div>
          <div className="identificationCTA">
            <span className="title">
              {translate({ ...messages.homePageTitle }, props)}
            </span>
            <span className="subTitle">
              {translate({ ...messages.homePageSubTitle }, props)}
            </span>
            <PrimaryButton
              onClick={pushTo(PAGES.IDENTIFICATION)}
              lefticon={<ArrowForwardIcon />}
              title={translate({ ...messages.homePagePreOpeningButton }, props)}
            />
          </div>
        </div>
      </Container>
      <Claims>
        <div className="claims">
          <div className="validatedClaims">
            <ValidatedClaims claims={props.statsClaims.validated} />
          </div>
          <div className="pendingClaims">
            <PendingClaims claims={props.statsClaims.pending} />
          </div>
        </div>
      </Claims>
    </div>
  );
};
const mapDispatchToProps = {
  requestStatsClaims,
};

const mapStateToProps = createStructuredSelector({
  statsClaims: makeSelectStatsClaims(),
  keyclokToken: makeSelectKeycloakToken(),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(HomePage));
